import { CreateReportRequest } from 'src/components/enterprise/features/Reporting/CreateReportsPage/api/createReportApi';
import { transformDateUIToModel } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/DateRangePicker/DateRangePicker.utils';
import { transformLocationsToIds } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/LocationsSelectControl/LocationsSelectControl.utils';
import { CreateReportFormFields } from 'src/components/enterprise/features/Reporting/CreateReportsPage/components/Form/CreateReportForm/CreateReportFormProvider';

export const transformEmployeeEmailToOptionalFilters = (
  email: string
): { employeeEmails: string[] } | undefined => {
  const trimmedEmail = email?.trim();
  return trimmedEmail ? { employeeEmails: [trimmedEmail] } : undefined;
};

export const transformCreateReportFormToPayload = (
  values: CreateReportFormFields,
  uniqueReportName: string
): CreateReportRequest => {
  const { reportName, startDate, endDate, locations, employeeEmail } = values;

  return {
    exportName: reportName,
    uniqueReportName,
    startDate: transformDateUIToModel(startDate),
    endDate: transformDateUIToModel(endDate),
    optionalFilters: {
      employeeLocationIds: transformLocationsToIds(locations),
      ...transformEmployeeEmailToOptionalFilters(employeeEmail),
    },
  };
};
